// dataStore.js
import React, { createContext, useContext, useState } from 'react';

// Create Context
const AppDataContext = createContext();
 
// Initial data
const initialAppData = {
  nextBatchDate: 'Aug 23, 2026',
  nextWebinarDate: 'Aug 22, 2026',
  nextWebinarTime: '11.00am',
  supportEmail: "support@ojasamirai.com",
  phone: "+91-9900309000",
  whatsappLink: "https://wa.me/919900309000",
  discordUrl: 'https://discord.com/channels/1404494048936591390/1408119821048090776',
  course1: {startDate: 'Aug 22, 2026',
            WebinarDate: 'Aug 23, 2026',
            shortName: 'GenAI+Full Stack',
            track: 'Full Course',
            emi: '9,999/month for 6 months (EMI)',
            price: '59,994',
            mrp: '1,25,000',
            link: '/beginner-track',
            offering: "Includes mentorship, cloud credits, career support, and access to materials for 1 year and lifetime access to community."
            },
  course2: {
            startDate: 'Aug 29, 2026',
            WebinarDate: 'Aug 30, 2026',
            shortName: 'GenAI+Full Stack',
            track: 'Fast-track',
            emi: '14,999/month for 2 months (EMI)',
            price: '29,998',
            mrp: '69,999',
            link: '/experienced-track',
            offering: "Includes mentorship, cloud credits, career support, and access to materials for 1 year and lifetime access to community."
            },
  course3: {
            startDate: 'June 14, 2026',
            WebinarDate: 'June 13, 2026',
            duration: '3 weeks',
            sessions: '11 core + 2 bonus sessions',

            shortName: 'Elite AI Engineering',
            track: 'Mastery Track',
            emi: 'One-time payment',
            price: '9,999',
            mrp: '19,999',
            link: '/ai-mastery',
            level: 'Experienced Developers',
            offering: "Includes mentorship, cloud credits, career support, and access to materials for 1 year and lifetime access to community."
            },
  course4: {
            duration: '1 week',
            sessions: '1 Intro + 4 sessions',
            emi: '-',
            price: 'Free',
            mrp: '999',

            shortName: 'GenAI+Full Stack - Demo',
            track: 'Mastery Track',
            link: '/ai-mastery',
            level: 'Beginners/fresh grads',
            offering: "You will have access to all the tools during the short course, and a selected set of tools will remain available even after the course ends."
            },
  course5: {
            duration: '1 week',
            sessions: '1 Intro + 4 sessions',
            emi: '-',
            price: 'Free',
            mrp: '999',

            shortName: 'GenAI+Full Stack',
            track: 'Fast-track',
            link: '/experienced-track',
            offering: "Includes mentorship, cloud credits, career support, and access to materials for 1 year and lifetime access to community."
            },
  course6: {
            courseId: '6',
            startDate: 'Sep 28, 2026',
            WebinarDate: 'Sep 27, 2026',
            shortName: 'Full Cycle Pro',
            track: '5-Week Full Lifecycle Sprint',
            emi: 'One-time payment',
            price: '9,999',
            mrp: '21,000',
            link: '/transform/6',
            level: 'Can already write basic code',
            offering: "Includes 5 weeks of daily live classes, 4 dedicated 1:1 mentor sessions, 100,000 AI credits, 50,000 cloud credits, a completion certificate, and ₹8,000 off our AI-Engineer course afterward. +18% GST extra; bring your own Claude Code subscription."
            },
  courseCollege: {
          duration: '12 weeks',
          sessions: '1 Intro + 4 sessions',
          emi: '5,999/month for 2 months (EMI)',
          price: '11,998',
          mrp: '29,999',

          shortName: 'Fullstack+AI for College Students',
          track: 'College Project Track',
          link: '/college-project',
          level: 'College Students',
          offering: "Includes mentorship, cloud credits, career support, and access to materials for 1 year and lifetime access to community."
          },
  course11: {
          courseId: '11',
          startDate: '2026-07-20',
          WebinarDate: '2026-07-19',
          duration: '4 weeks',
          sessions: '4 live sessions + 1 practice session per week',

          shortName: 'Full Stack Mastery',
          track: 'AI + Full Stack',
          emi: 'One-time payment',
          price: '9,999',
          mrp: '11,999',
          link: '/course/11',
          level: 'Freshers & Career Switchers',
          offering: "Includes 4 live sessions per week, 1 hands-on practice session, Discord community, career support with online grooming, portfolio review, interview prep, and 3-day video recording access."
          },

  webinarAttendedCount: 500,
  studentsCount: 300,
  placementRate: 80,
  salaryIncrease: "₹5L → ₹10L avg",
  projects: "10+ production projects", 
  timeframe: "6 months to placement",
  completionRate: "95%",
   averageRating: "4.8/5"
  // Add more global data here as needed
};

// Provider Component
export const AppDataProvider = ({ children, initialData = initialAppData }) => {
  const [appData, setAppData] = useState(initialData);

  // Function to update data
  const updateAppData = (key, value) => {
    setAppData(prev => ({
      ...prev,
      [key]: value
    }));
  };

  // Function to update multiple values
  const updateMultipleData = (updates) => {
    setAppData(prev => ({
      ...prev,
      ...updates
    }));
  };

  const value = {
    appData,
    updateAppData,
    updateMultipleData,
  };

  return (
    <AppDataContext.Provider value={value}>
      {children}
    </AppDataContext.Provider>
  );
};

// Custom Hook
export const useAppData = () => {
  const context = useContext(AppDataContext);
  if (!context) {
    throw new Error('useAppData must be used within an AppDataProvider');
  }
  return context;
};

// Export initial data for direct imports
export const appData = initialAppData;